export const getDataWithPercentageValues = data => {
  const sum = data.reduce((acc, item) => acc + item.value, 0);
  let totalPercentage = 0;

  const dataWithPercentages = data.reduce((acc, item, index) => {
    let percentage;
    if (index === data.length - 1) {
      percentage = 100 - totalPercentage;
    } else {
      percentage = Math.round((item.value / sum) * 100);
      totalPercentage += percentage;
    }

    return [...acc, { ...item, percentage }];
  }, []);

  return dataWithPercentages;
};
